import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import STRINGS from "Constants/Strings";
import AuthBody from "../Common/AuthBody/AuthBody";
import { isInBranchFlow } from "../../Utils/LogicUtilities";
import { Modal, Table } from "react-bootstrap";
import { doAccountSearch } from "../../Redux/Actions/AccountSearchAction";
import AppConstants from "../../Constants/AppConstants";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { subYears, parse, format, getYear, getMonth, parseISO } from "date-fns";

class ExistingMember extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      choice: "",
      showModal: false,
      search: {
        firstName: "",
        middleName: "",
        lastName: "",
        dob: "",
        sin4: "",
        pan: "",
        memberNumber: "",
        mobile: "",
        home: "",
        email: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        country: "CAN",
      },
      showAdditionalFields: false,
      searchResults: [],
      isLoading: false,
      pagination: {
        currentPage: 0,
        pageSize: 10,
        totalElements: 0,
        totalPages: 0,
        hasNext: false,
        hasPrevious: false,
      },
      hasSearched: false,
      isDatePickerOpen: false,
      applicantId: null,
      searchError: "",
      // Validation error states
      mobileError: "",
      homeError: "",
      emailError: "",
      // Sorting state
      sortConfig: {
        sortBy: "firstName",
        sortDirection: "ASC",
      },
    };
  }

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  handleChange = (choice) => {
    this.setState({ choice });
    const { inSessionJointApplicant } = this.props;
    if (choice === true && isInBranchFlow() && !!inSessionJointApplicant) {
      this.setState({ showModal: true });
    }
  };

  handleContinue = () => {
    const { handleContinue } = this.props;
    const { choice } = this.state;
    this.clearChoice();
    handleContinue(choice);
  };

  clearChoice = () => {
    this.setState({ choice: "" });
  };

  handleCloseModal = () => {
    this.setState({
      showModal: false,
      choice: "",
      search: {
        firstName: "",
        middleName: "",
        lastName: "",
        dob: "",
        sin4: "",
        pan: "",
        memberNumber: "",
        mobile: "",
        home: "",
        email: "",
        address: "",
        city: "",
        state: "",
        zip: "",
        country: "CAN",
      },
      searchResults: [],
      showAdditionalFields: false,
      hasSearched: false,
      searchError: "",
      mobileError: "",
      homeError: "",
      emailError: "",
      applicantId: null,
      pagination: {
        currentPage: 0,
        pageSize: 10,
        totalElements: 0,
        totalPages: 0,
        hasNext: false,
        hasPrevious: false,
      },
    });
  };

  handleInputChange = (event) => {
    const { name, value } = event.target;
    this.setState({
      search: {
        ...this.state.search,
        [name]: value,
      },
    });
  };

  // Custom firstName input handler to only allow valid name characters
  handleFirstNameInputChange = (event) => {
    const { value } = event.target;

    // Allow only letters, spaces, hyphens, apostrophes, and periods
    // This covers most valid name characters including:
    // - Regular names: John, Mary
    // - Compound names: Mary Jane
    // - Hyphenated names: Jean-Pierre
    // - Names with apostrophes: O'Connor, D'Angelo
    // - Names with periods: Jr., Sr.
    const namePattern = /^[a-zA-Z\s\-'.]*$/;

    if (namePattern.test(value)) {
      this.handleInputChange({
        target: {
          name: "firstName",
          value: value,
        },
      });
    }
    // If the pattern doesn't match, the input is ignored (no state update)
  };

  // Custom middleName input handler to only allow valid name characters
  handleMiddleNameInputChange = (event) => {
    const { value } = event.target;

    // Allow only letters, spaces, hyphens, apostrophes, and periods
    const namePattern = /^[a-zA-Z\s\-'.]*$/;

    if (namePattern.test(value)) {
      this.handleInputChange({
        target: {
          name: "middleName",
          value: value,
        },
      });
    }
    // If the pattern doesn't match, the input is ignored (no state update)
  };

  // Custom lastName input handler to only allow valid name characters
  handleLastNameInputChange = (event) => {
    const { value } = event.target;

    // Allow only letters, spaces, hyphens, apostrophes, and periods
    const namePattern = /^[a-zA-Z\s\-'.]*$/;

    if (namePattern.test(value)) {
      this.handleInputChange({
        target: {
          name: "lastName",
          value: value,
        },
      });
    }
    // If the pattern doesn't match, the input is ignored (no state update)
  };

  // Personal member search function - separated into two parts to avoid auto-search on search parameter changes
  executePersonalSearch = (searchParams) => {
    if (
      !searchParams.firstName &&
      !searchParams.middleName &&
      !searchParams.lastName &&
      !searchParams.dob &&
      !searchParams.sin4 &&
      !searchParams.pan &&
      !searchParams.memberNumber &&
      !searchParams.mobile &&
      !searchParams.home &&
      !searchParams.email &&
      !searchParams.address &&
      !searchParams.city &&
      !searchParams.state &&
      !searchParams.zip
    ) {
      console.log("No search criteria");
      this.setState({
        searchError: "At least one field is required to initiate a search.",
      });
      return;
    }

    // Clear previous validation errors
    this.setState({
      mobileError: "",
      homeError: "",
      emailError: "",
    });

    let hasValidationErrors = false;

    // Validate email if there is a value
    if (searchParams.email && searchParams.email.trim() !== "") {
      const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/i;
      if (!emailPattern.test(searchParams.email)) {
        this.setState({ emailError: "Enter a valid email address." });
        hasValidationErrors = true;
      }
    }

    // Validate mobile if there is a value
    if (searchParams.mobile && searchParams.mobile.trim() !== "") {
      const mobilePattern = /^[0-9]{10}$/;
      if (!mobilePattern.test(searchParams.mobile)) {
        this.setState({ mobileError: "Enter valid mobile no." });
        hasValidationErrors = true;
      }
    }

    // Validate home if there is a value
    if (searchParams.home && searchParams.home.trim() !== "") {
      const homePattern = /^[0-9]{10}$/;
      if (!homePattern.test(searchParams.home)) {
        this.setState({ homeError: "Enter valid home no." });
        hasValidationErrors = true;
      }
    }

    // Only proceed with search if there are no validation errors
    if (!hasValidationErrors) {
      this.setState({
        searchError: "",
        isLoading: true,
        hasSearched: true,
      });
    } else {
      return;
    }

    // Store the search parameters for pagination/sorting
    this.lastSearchParams = searchParams;

    // Map form fields to API fields
    const searchCriteria = {
      firstName: searchParams.firstName || "",
      middleName: searchParams.middleName || "",
      lastName: searchParams.lastName || "",
      dateOfBirth: searchParams.dob
        ? format(new Date(searchParams.dob), "yyyy-MM-dd")
        : null,
      sin: searchParams.sin4 || "",
      pan: searchParams.pan || "",
      memberNumber: searchParams.memberNumber || "",
      mobileNumber: searchParams.mobile || "",
      homeNumber: searchParams.home || "",
      email: searchParams.email || "",
      address: searchParams.address || "",
      city: searchParams.city || "",
      province: searchParams.state || "",
      postalCode: searchParams.zip ? searchParams.zip.replace(/\s/g, "") : "",
      country: searchParams.country || "",
      bankingType: AppConstants.BANKING_TYPE.PERSONAL,
      page: this.state.pagination.currentPage,
      size: this.state.pagination.pageSize,
      memberOnly: true,
      // Add sorting parameters
      sortBy: this.state.sortConfig.sortBy,
      sortDirection: this.state.sortConfig.sortDirection,
    };

    this.props.doAccountSearch(searchCriteria, (response) => {
      this.setState({ isLoading: false });

      if (response.error) {
        console.error("Search failed:", response.error);
        this.setState({
          searchResults: [],
          pagination: {
            currentPage: 0,
            pageSize: 10,
            totalElements: 0,
            totalPages: 0,
            hasNext: false,
            hasPrevious: false,
          },
        });
      } else {
        console.log("Search results:", response);
        // Handle both direct response and nested data structure
        const responseData = response.data || response;
        this.setState({
          searchResults: responseData?.results || [],
          pagination: {
            currentPage: responseData?.currentPage || 0,
            pageSize: responseData?.pageSize || 10,
            totalElements: responseData?.totalElements || 0,
            totalPages: responseData?.totalPages || 0,
            hasNext: responseData?.hasNext || false,
            hasPrevious: responseData?.hasPrevious || false,
          },
        });
      }
    });
  };

  // Function for explicit search button clicks - gets current search values
  handlePersonalSearch = () => {
    console.log("handlePersonalSearch", this.state.search);
    this.executePersonalSearch(this.state.search);
  };

  // Handle Enter key press on search input fields
  handleKeyDown = (event) => {
    if (event.key === "Enter") {
      event.preventDefault();
      this.handlePersonalSearch();
    }
  };

  // Function for pagination/sorting - uses stored search parameters
  handlePersonalSearchWithStoredParams = () => {
    if (this.lastSearchParams) {
      this.executePersonalSearch(this.lastSearchParams);
    }
  };

  handleSelectMember = (member) => {
    // Handle member selection - you can customize this based on your needs
    console.log("Selected member:", member);
    this.setState({ applicantId: member.applicantId });
    // You might want to call a prop function here to handle the selected member
    if (this.props.onMemberSelected) {
      this.props.onMemberSelected(member);
    }
  };

  // Sort handler function
  handleSort = (field) => {
    const newDirection =
      this.state.sortConfig.sortBy === field &&
      this.state.sortConfig.sortDirection === "ASC"
        ? "DESC"
        : "ASC";

    this.setState(
      {
        sortConfig: {
          sortBy: field,
          sortDirection: newDirection,
        },
        pagination: {
          ...this.state.pagination,
          currentPage: 0, // Reset to first page when sorting
        },
      },
      () => {
        // Trigger search with new sorting parameters
        this.handlePersonalSearchWithStoredParams();
      }
    );
  };

  formatPhoneNumber = (phoneNumber) => {
    if (!phoneNumber) return "-";

    // Remove all non-digit characters
    const cleaned = phoneNumber.replace(/\D/g, "");

    // Check if it's a 10-digit number (assuming North American format)
    if (cleaned.length === 10) {
      return `+1 (${cleaned.slice(0, 3)}) ${cleaned.slice(
        3,
        6
      )}-${cleaned.slice(6)}`;
    }

    // If it's 11 digits and starts with 1, format accordingly
    if (cleaned.length === 11 && cleaned.startsWith("1")) {
      return `+1 (${cleaned.slice(1, 4)}) ${cleaned.slice(
        4,
        7
      )}-${cleaned.slice(7)}`;
    }

    // Return original if it doesn't match expected format
    return phoneNumber;
  };

  handleZipInputChange = (e) => {
    const { search } = this.state;
    const { value } = e.target;
    const country = search.country;

    let isValid = false;
    let filteredValue = value;

    if (country === "USA") {
      // USA: Accept numeric values only (ZIP code format)
      filteredValue = value.replace(/[^0-9]/g, "");
      isValid = /^[0-9]*$/.test(filteredValue);
    } else if (country === "CAN") {
      // Canada: Accept alphanumeric and space (Canadian postal code format A1A 1A1)
      // Remove any characters that aren't letters, numbers, or spaces
      let cleanValue = value.replace(/[^a-zA-Z0-9\s]/g, "").toUpperCase();

      // Format as user types: A1A 1A1
      if (cleanValue.length > 0) {
        // Remove existing spaces to reformat
        let noSpaces = cleanValue.replace(/\s/g, "");

        // Apply Canadian postal code formatting
        if (noSpaces.length <= 6) {
          if (noSpaces.length > 3) {
            filteredValue = noSpaces.slice(0, 3) + " " + noSpaces.slice(3);
          } else {
            filteredValue = noSpaces;
          }

          // Validate Canadian postal code pattern (partial or complete)
          // Allow partial input while typing: A, A1, A1A, A1A , A1A 1, A1A 1A, A1A 1A1
          isValid = /^[A-Z]?([0-9][A-Z]?(\s[0-9]?[A-Z]?[0-9]?)?)?$/.test(
            filteredValue
          );
        } else {
          // Too many characters, don't allow
          isValid = false;
        }
      } else {
        filteredValue = "";
        isValid = true; // Allow empty value
      }
    } else {
      // Default: allow any input for other countries
      isValid = true;
    }

    if (isValid) {
      this.handleInputChange({
        target: {
          name: "zip",
          value: filteredValue,
        },
      });
    }
  };

  // Sortable header component
  SortableHeader = ({ field, label }) => {
    const getSortIcon = () => {
      if (this.state.sortConfig.sortBy !== field) {
        return (
          <i
            className="fas fa-sort"
            style={{ fontSize: "10px", marginLeft: "4px" }}
          ></i>
        ); // Both arrows when not sorted
      }
      return this.state.sortConfig.sortDirection === "ASC" ? "▲" : "▼";
    };

    return (
      <th
        onClick={() => this.handleSort(field)}
        style={{
          cursor: "pointer",
          userSelect: "none",
          position: "relative",
        }}
        className="sortable-header"
      >
        {label}
        <span style={{ marginLeft: "5px", fontSize: "0.8em", color: "#666" }}>
          {getSortIcon()}
        </span>
      </th>
    );
  };

  renderPersonalMembers = () => {
    const {
      search,
      showAdditionalFields,
      searchResults,
      isLoading,
      hasSearched,
      pagination,
      isDatePickerOpen,
      applicantId,
      searchError,
    } = this.state;
    const { provinceList } = this.props;
    return (
      <>
        <div className="mb-3">
          <div className="[ row ]">
            <div className="[  col-12 col-lg-3 ]">
              <div className="[ mb-3 ]">
                <label className="form-label">First name</label>
                <input
                  type="text"
                  className="form-control"
                  name="firstName"
                  value={search.firstName}
                  onChange={this.handleFirstNameInputChange}
                  onKeyDown={this.handleKeyDown}
                  maxLength={50}
                />
              </div>
            </div>
            <div className="[  col-12 col-lg-3 ]">
              <div className="[ mb-3 ]">
                <label className="form-label">Middle name</label>
                <input
                  className="form-control"
                  name="middleName"
                  value={search.middleName}
                  onChange={this.handleMiddleNameInputChange}
                  onKeyDown={this.handleKeyDown}
                  placeholder="If applicable"
                  maxLength={50}
                />
              </div>
            </div>
            <div className="[  col-12 col-lg-3 ]">
              <div className="[ mb-3 ]">
                <label className="form-label">Last name</label>
                <input
                  className="form-control"
                  name="lastName"
                  value={search.lastName}
                  onChange={this.handleLastNameInputChange}
                  onKeyDown={this.handleKeyDown}
                  maxLength={50}
                />
              </div>
            </div>
            <div className="[  col-12 col-lg-3 ]">
              <div className="[ mb-3 ]">
                <label className="form-label">Date of birth</label>
                <DatePicker
                  className="form-control"
                  dateFormat="MM-dd-yyyy"
                  placeholderText="MM-DD-YYYY"
                  selected={
                    search.dob
                      ? parse(search.dob, "MM-dd-yyyy", new Date())
                      : null
                  }
                  open={isDatePickerOpen}
                  onClickOutside={() =>
                    this.setState({ isDatePickerOpen: false })
                  }
                  onFocus={() => this.setState({ isDatePickerOpen: true })}
                  onChange={(date) => {
                    const formattedDate = date
                      ? format(date, "MM-dd-yyyy")
                      : "";
                    this.handleInputChange({
                      target: {
                        name: "dob",
                        value: formattedDate,
                      },
                    });
                    this.setState({ isDatePickerOpen: false });
                  }}
                  onChangeRaw={(e) => {
                    const { value } = e.target;
                    // Only allow numbers and hyphens for date format MM-dd-yyyy
                    const validChars = /^[0-9\-]*$/;
                    if (!validChars.test(value)) {
                      e.preventDefault();
                      return;
                    }
                    // Allow the change if it matches valid characters
                    // The DatePicker will handle validation of the actual date
                  }}
                  minDate={subYears(new Date(), 100)}
                  maxDate={subYears(new Date(), 12)}
                  popperProps={{
                    style: { zIndex: 99999 },
                    className: "datepicker-popper-high-z",
                  }}
                  popperPlacement="bottom-start"
                  renderCustomHeader={({
                    date,
                    changeYear,
                    changeMonth,
                    decreaseMonth,
                    increaseMonth,
                    prevMonthButtonDisabled,
                    nextMonthButtonDisabled,
                  }) => {
                    const years = Array.from(
                      { length: 100 },
                      (_, i) => getYear(new Date()) - 12 - i
                    );
                    const months = [
                      "Jan",
                      "Feb",
                      "Mar",
                      "Apr",
                      "May",
                      "Jun",
                      "Jul",
                      "Aug",
                      "Sep",
                      "Oct",
                      "Nov",
                      "Dec",
                    ];
                    return (
                      <div className="custom-datepicker-header">
                        {/* Clear button at the top */}
                        <div className="custom-datepicker-clear-section">
                          <button
                            type="button"
                            onClick={() => {
                              this.handleInputChange({
                                target: {
                                  name: "dob",
                                  value: "",
                                },
                              });
                              this.setState({ isDatePickerOpen: false });
                            }}
                            style={{
                              padding: "4px 8px",
                              border: "1px solid #dc3545",
                              background: "#dc3545",
                              color: "white",
                              borderRadius: "4px",
                              cursor: "pointer",
                              fontSize: "12px",
                            }}
                            title="Clear date"
                          >
                            Clear
                          </button>
                        </div>
                        <div className="custom-datepicker-nav-section">
                          <button
                            type="button"
                            onClick={decreaseMonth}
                            disabled={prevMonthButtonDisabled}
                            style={{
                              padding: "4px 8px",
                              border: "1px solid #ccc",
                              background: "#fff",
                              cursor: "pointer",
                            }}
                          >
                            {"<"}
                          </button>
                          <select
                            value={getYear(date)}
                            onChange={({ target: { value } }) =>
                              changeYear(value)
                            }
                            style={{
                              padding: "4px",
                              border: "1px solid #ccc",
                            }}
                          >
                            {years.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                          <select
                            value={months[getMonth(date)]}
                            onChange={({ target: { value } }) =>
                              changeMonth(months.indexOf(value))
                            }
                            style={{
                              padding: "4px",
                              border: "1px solid #ccc",
                            }}
                          >
                            {months.map((option) => (
                              <option key={option} value={option}>
                                {option}
                              </option>
                            ))}
                          </select>
                          <button
                            type="button"
                            onClick={increaseMonth}
                            disabled={nextMonthButtonDisabled}
                            style={{
                              padding: "4px 8px",
                              border: "1px solid #ccc",
                              background: "#fff",
                              cursor: "pointer",
                            }}
                          >
                            {">"}
                          </button>
                        </div>
                      </div>
                    );
                  }}
                />
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-12 d-flex justify-content-end">
              <span
                className="text-danger"
                style={{ cursor: "pointer", fontSize: "0.95em" }}
                tabIndex={0}
                onClick={() =>
                  this.setState({ showAdditionalFields: !showAdditionalFields })
                }
                onKeyDown={(e) => {
                  if (e.key === "Enter" || e.key === " ") {
                    e.preventDefault();
                    this.setState({
                      showAdditionalFields: !showAdditionalFields,
                    });
                  }
                }}
              >
                <i className="fas fa-filter me-1"></i> Additional Search Fields{" "}
                <i
                  className={
                    showAdditionalFields
                      ? "fas fa-caret-down ms-1"
                      : "fas fa-caret-right ms-1"
                  }
                ></i>
              </span>
            </div>
          </div>
          {showAdditionalFields && (
            <div className="[ App drawer-content-container ]">
              <div className="row mb-3">
                <div className="col-md-3 mb-3 mb-md-0">
                  <label className="form-label">SSN / SIN</label>
                  <input
                    className="form-control"
                    name="sin4"
                    placeholder={"eg. 123456789"}
                    value={search.sin4 || ""}
                    onChange={(e) => {
                      // Only allow numeric input
                      const value = e.target.value.replace(/\D/g, "");
                      const maxLength = 9;
                      const limitedValue = value.slice(0, maxLength);
                      this.handleInputChange({
                        target: {
                          name: "sin4",
                          value: limitedValue,
                        },
                      });
                    }}
                    onKeyDown={this.handleKeyDown}
                    maxLength={9}
                  />
                </div>
              </div>
              <div className="[ divider ]" />
              <div className="row mb-3">
                <div className="col-md-6 mb-3 mb-md-0">
                  <label className="form-label">PAN no.</label>
                  <input
                    className="form-control"
                    name="pan"
                    placeholder="eg. 1234567890123456"
                    value={search.pan || ""}
                    onChange={(e) => {
                      // Only allow numeric input
                      const value = e.target.value.replace(/\D/g, "");
                      // Limit to 16 digits (typical PAN length)
                      const limitedValue = value.slice(0, 16);
                      this.handleInputChange({
                        target: {
                          name: "pan",
                          value: limitedValue,
                        },
                      });
                    }}
                    onKeyDown={this.handleKeyDown}
                    maxLength={16}
                  />
                </div>
                <div className="col-md-6">
                  <label className="form-label">Member ID</label>
                  <input
                    className="form-control"
                    name="memberNumber"
                    placeholder="eg. 12345678"
                    value={search.memberNumber || ""}
                    onChange={(e) => {
                      // Only allow alphanumeric characters (letters and numbers)
                      const value = e.target.value.replace(/[^a-zA-Z0-9]/g, "");
                      this.handleInputChange({
                        target: {
                          name: "memberNumber",
                          value: value,
                        },
                      });
                    }}
                    onKeyDown={this.handleKeyDown}
                    maxLength={12}
                  />
                </div>
              </div>
              <div className="[ divider ]" />
              <div className="row mb-3">
                <div className="col-md-4 mb-3 mb-md-0">
                  <label className="form-label">Mobile no.</label>
                  <input
                    className="form-control"
                    name="mobile"
                    placeholder="eg. 7783765555"
                    value={search.mobile || ""}
                    onChange={(e) => {
                      // Clear mobileError when user edits the mobile field
                      this.setState({ mobileError: "" });

                      // Only allow numeric input
                      const value = e.target.value.replace(/\D/g, "");
                      this.handleInputChange({
                        target: {
                          name: "mobile",
                          value: value,
                        },
                      });
                    }}
                    onKeyDown={this.handleKeyDown}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength="10"
                  />
                  <div
                    className="[ error-msg ]"
                    style={{ marginBottom: "0", height: "0.6vh" }}
                  >
                    {this.state.mobileError}
                  </div>
                </div>
                <div className="col-md-4 mb-3 mb-md-0">
                  <label className="form-label">Home no.</label>
                  <input
                    className="form-control"
                    name="home"
                    placeholder="eg. 7783765555"
                    value={search.home || ""}
                    onChange={(e) => {
                      // Clear homeError when user edits the home field
                      this.setState({ homeError: "" });

                      // Only allow numeric input
                      const value = e.target.value.replace(/\D/g, "");
                      this.handleInputChange({
                        target: {
                          name: "home",
                          value: value,
                        },
                      });
                    }}
                    onKeyDown={this.handleKeyDown}
                    inputMode="numeric"
                    pattern="[0-9]*"
                    maxLength="10"
                  />
                  <div
                    className="[ error-msg ]"
                    style={{ marginBottom: "0", height: "0.6vh" }}
                  >
                    {this.state.homeError}
                  </div>
                </div>
                <div className="col-md-4">
                  <label className="form-label">Email</label>
                  <input
                    className="form-control"
                    name="email"
                    placeholder="eg. email@email.com"
                    value={search.email || ""}
                    onChange={(e) => {
                      // Clear emailError when user edits the email field
                      this.setState({ emailError: "" });

                      // Basic email validation pattern
                      const emailPattern = /^[^\s@]*@?[^\s@]*$/;
                      const value = e.target.value;

                      // Allow empty value or valid email format
                      if (value === "" || emailPattern.test(value)) {
                        this.handleInputChange({
                          target: {
                            name: "email",
                            value: value,
                          },
                        });
                      }
                    }}
                    onKeyDown={this.handleKeyDown}
                    pattern="[a-z0-9._%+\-]+@[a-z0-9.\-]+\.[a-z]{2,}$"
                    maxLength={50}
                  />
                  <div
                    className="[ error-msg ]"
                    style={{ marginBottom: "0", height: "0.6vh" }}
                  >
                    {this.state.emailError}
                  </div>
                </div>
              </div>
              <div className="[ divider ]" />
              <div className="mb-3">
                <label className="form-label">Residential address</label>
                <input
                  className="form-control"
                  name="address"
                  placeholder="eg. 1601 W Space Needle Dr."
                  value={search.address || ""}
                  onChange={this.handleInputChange}
                  onKeyDown={this.handleKeyDown}
                />
                <small className="text-muted">
                  Start typing an address to auto-fill this information.
                </small>
              </div>
              <div className="row mb-3">
                <div className="col-md-3 mb-3 mb-md-0">
                  <label className="form-label">City</label>
                  <input
                    className="form-control"
                    name="city"
                    placeholder={
                      search.country === "USA" ? "eg. Seattle" : "eg. Vancouver"
                    }
                    value={search.city || ""}
                    onChange={this.handleInputChange}
                    onKeyDown={this.handleKeyDown}
                    maxLength={50}
                  />
                </div>
                <div className="col-md-3 mb-3 mb-md-0">
                  <label className="form-label">State / territory</label>
                  <select
                    className="form-control"
                    name="state"
                    value={search.state || ""}
                    onChange={this.handleInputChange}
                  >
                    <option value="">Select a state / territory</option>
                    {provinceList.map((province) => {
                      if (province.country === search.country) {
                        return (
                          <option key={province.code} value={province.code}>
                            {province.description}
                          </option>
                        );
                      }
                      return null;
                    })}
                  </select>
                </div>
                <div className="col-md-3 mb-3 mb-md-0">
                  <label className="form-label">ZIP</label>
                  <input
                    className="form-control"
                    name="zip"
                    placeholder={
                      search.country === "USA" ? "eg. 98101" : "eg. V4N 6R3"
                    }
                    value={search.zip || ""}
                    onChange={this.handleZipInputChange}
                    onKeyDown={this.handleKeyDown}
                  />
                </div>
                <div className="col-md-3">
                  <label className="form-label">Country</label>
                  <select
                    className="form-control"
                    name="country"
                    value={search.country}
                    onChange={this.handleInputChange}
                  >
                    <option value=""></option>
                    <option value="CAN">Canada</option>
                    <option value="USA">USA</option>
                  </select>
                </div>
              </div>
            </div>
          )}
          <div
            className="col-xl-6 col-lg-6 col-md-6 col-12"
            style={
              showAdditionalFields
                ? { paddingTop: "1rem" }
                : { marginTop: "-1rem" }
            }
          >
            <button
              className="btn btn-primary me-3"
              onClick={this.handlePersonalSearch}
            >
              SEARCH
            </button>
            <div
              className="[ error-msg ]"
              style={{ fontSize: "80%", color: "#ff0000", paddingTop: "1em" }}
            >
              {searchError}
            </div>
          </div>
        </div>
        <div className="row">
          <div className="col-xl-6 col-lg-6 col-md-6 col-12">
            <span
              className="ms-auto fw-bold"
              style={{
                cursor: "pointer",
                fontSize: "0.95em",
                fontWeight: "bold",
              }}
            >
              Displaying 'Personal' Members
            </span>
          </div>
          <div className="col-xl-6 col-lg-6 col-md-6 col-12 d-flex justify-content-end">
            <span
              className="ms-auto text-primary d-flex"
              style={{
                marginLeft: "auto",
                cursor: "pointer",
                fontSize: "0.95em",
              }}
              onClick={this.handlePersonalSearch}
            >
              <i
                className="fas fa-sync me-1"
                style={{ paddingRight: "0.5rem", marginTop: "4px" }}
              ></i>{" "}
              Refresh Table
            </span>
          </div>
        </div>
        <div
          className="d-flex align-items-center justify-content-between mb-2"
          style={{ paddingTop: "1rem" }}
        >
          <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
            <span style={{ fontSize: 12 }}>Items per page:</span>
            <select
              className="form-select form-select-sm"
              style={{ width: "60px", fontSize: 12 }}
              value={pagination.pageSize}
              onChange={(e) => {
                const newPageSize = parseInt(e.target.value, 10);
                this.setState((prevState) => ({
                  pagination: {
                    ...prevState.pagination,
                    pageSize: newPageSize,
                    currentPage: 0,
                  },
                }));
              }}
            >
              <option>10</option>
              <option>20</option>
              <option>30</option>
            </select>
          </div>
          <div className="d-flex align-items-center" style={{ gap: "0.5rem" }}>
            <select
              className="form-select form-select-sm"
              style={{ width: "50px", fontSize: 12 }}
              value={pagination.currentPage + 1}
              onChange={(e) => {
                const newPage = parseInt(e.target.value, 10) - 1;
                this.setState(
                  (prevState) => ({
                    pagination: {
                      ...prevState.pagination,
                      currentPage: newPage,
                    },
                  }),
                  () => {
                    this.handlePersonalSearchWithStoredParams();
                  }
                );
              }}
            >
              {Array.from(
                { length: Math.max(1, pagination.totalPages) },
                (_, i) => (
                  <option key={i + 1} value={i + 1}>
                    {i + 1}
                  </option>
                )
              )}
            </select>
            <span style={{ fontSize: 12 }}>
              of {pagination.totalPages || 1}
            </span>
            <button
              className="btn btn-sm btn-outline-secondary btn-paging"
              style={{ fontSize: 12, minWidth: "32px", height: "32px" }}
              disabled={pagination.currentPage === 0}
              onClick={() => {
                if (pagination.currentPage > 0) {
                  this.setState(
                    (prevState) => ({
                      pagination: {
                        ...prevState.pagination,
                        currentPage: prevState.pagination.currentPage - 1,
                      },
                    }),
                    () => {
                      this.handlePersonalSearchWithStoredParams();
                    }
                  );
                }
              }}
            >
              <i className="fas fa-chevron-left"></i>
            </button>
            <button
              className="btn btn-sm btn-outline-secondary btn-paging"
              style={{ fontSize: 12, minWidth: "32px", height: "32px" }}
              disabled={pagination.currentPage >= pagination.totalPages - 1}
              onClick={() => {
                if (pagination.currentPage < pagination.totalPages - 1) {
                  this.setState(
                    (prevState) => ({
                      pagination: {
                        ...prevState.pagination,
                        currentPage: prevState.pagination.currentPage + 1,
                      },
                    }),
                    () => {
                      this.handlePersonalSearchWithStoredParams();
                    }
                  );
                }
              }}
            >
              <i className="fas fa-chevron-right"></i>
            </button>
          </div>
        </div>
        <div style={{ padding: 15, overflowX: "auto" }}>
          <Table
            striped
            hover
            size="sm"
            style={{ fontSize: 12, minWidth: "100%" }}
          >
            <thead>
              <tr>
                <th>SELECT</th>
                <this.SortableHeader field="firstName" label="FIRST NAME" />
                <this.SortableHeader field="middleName" label="MIDDLE NAME" />
                <this.SortableHeader field="lastName" label="LAST NAME" />
                <this.SortableHeader field="dateOfBirth" label="DOB" />
                <this.SortableHeader field="sin" label="SSN" />
                <this.SortableHeader field="memberNumber" label="MEMBER ID #" />
              </tr>
            </thead>
            <tbody>
              {isLoading ? (
                <tr>
                  <td colSpan={8} className="text-center text-muted py-4">
                    <div>
                      <i className="fas fa-spinner fa-spin me-2"></i>
                      Searching...
                    </div>
                  </td>
                </tr>
              ) : searchResults.length > 0 ? (
                searchResults.map((result, idx) => {
                  const isSelected = applicantId === result.applicantId;
                  return (
                    <tr key={result.id || idx}>
                      <td>
                        <button
                          className="btn btn-sm"
                          style={{
                            borderRadius: "8px",
                            padding: "0px 25px",
                            fontSize: "12px",
                            fontWeight: "400",
                            border: "2px solid #ccc",
                            minWidth: "80px",
                            backgroundColor: isSelected ? "#007bff" : "#fff",
                            color: isSelected ? "white" : "black",
                            cursor: "pointer",
                            transition: "all 0.2s ease",
                          }}
                          onClick={() => this.handleSelectMember(result)}
                        >
                          Select
                        </button>
                      </td>
                      <td>{result.firstName || ""}</td>
                      <td>{result.middleName || ""}</td>
                      <td>{result.lastName || ""}</td>
                      <td>
                        {result.dateOfBirth
                          ? format(parseISO(result.dateOfBirth), "MM-dd-yyyy")
                          : ""}
                      </td>
                      <td>
                        {result.sin ? `***-**-${result.sin.slice(-4)}` : ""}
                      </td>
                      <td>{result.memberNumber || ""}</td>
                    </tr>
                  );
                })
              ) : hasSearched ? (
                <tr>
                  <td colSpan={8} className="text-center text-muted py-4">
                    <div>
                      No members found matching your search criteria.
                      <br />
                      Double-check your search details, or try using the
                      additional search fields.
                    </div>
                  </td>
                </tr>
              ) : (
                <tr>
                  <td colSpan={8} className="text-center text-muted py-4">
                    <div>
                      Enter search criteria and click "SEARCH" to find members.
                    </div>
                  </td>
                </tr>
              )}
            </tbody>
          </Table>
        </div>
      </>
    );
  };

  render() {
    const { choice, showModal, applicantId } = this.state;
    const { handleContinueInBranchJoint } = this.props;

    const actionComponent = (
      <div className="[ existing-client-container ]">
        <div className="[ form-title-existing ]">
          {STRINGS.EXISTING_MEMBER.TITLE}
        </div>

        <div className="[ form-container ]">
          <div className="[ mb-3 ]">
            <div className="[ form-label ]">
              {STRINGS.EXISTING_MEMBER.CHOICE_MESSAGE}
            </div>

            <div className="[ row ] [ custom-radios ]">
              <div className="[ col-6 ]">
                <button
                  type="button"
                  className={
                    choice !== "" && choice
                      ? "[ btn custom-radio-selected ]"
                      : "[ btn custom-radio-unselected ]"
                  }
                  name="choice"
                  onClick={(event) => this.handleChange(true, event)}
                >
                  {STRINGS.COMMON.CHOICE.YES}
                </button>
              </div>

              <div className="[ col-6 ]">
                <button
                  type="submit"
                  className={
                    choice !== "" && !choice
                      ? "[ btn custom-radio-selected ]"
                      : "[ btn custom-radio-unselected ]"
                  }
                  name="choice"
                  onClick={(event) => this.handleChange(false, event)}
                >
                  {STRINGS.COMMON.CHOICE.NO}
                </button>
              </div>
            </div>
          </div>
        </div>

        <div className="[ mb-3 ]">
          <div className="[ row ]">
            <div className="[ col-lg-6 ] [ offset-lg-3 ]">
              <button
                type="button"
                className="[ btn  submit-btn ] [ w-100 ]"
                disabled={choice === ""}
                onClick={this.handleContinue}
              >
                {STRINGS.COMMON.CONTINUEBTN}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
    const infoComponent = (
      <div className="[ existing-client-secondary-container ]">
        <div className="[ info-title ]">
          <span className="lock-icon">
            {STRINGS.EXISTING_MEMBER.INFOBLOCK.TITLE}
          </span>
        </div>

        <div className="[ row ][ info-message ] [ p-3 ]">
          <span
            dangerouslySetInnerHTML={{
              __html: STRINGS.EXISTING_MEMBER.INFOBLOCK.DESCRIPTION,
            }}
          />
        </div>
      </div>
    );

    return (
      <>
        <AuthBody
          actionComponent={actionComponent}
          infoComponent={isInBranchFlow() ? null : infoComponent}
          handleBack={this.handleBack}
          renderInfoComponent
          showNavigationBar={false}
        />

        {/* Member Search Modal */}
        <Modal
          show={showModal}
          onHide={this.handleCloseModal}
          size="xl"
          centered
          backdrop="static"
        >
          <Modal.Header closeButton>
            <Modal.Title>
              <i className="fas fa-users"></i> PERSONAL MEMBER SEARCH
            </Modal.Title>
          </Modal.Header>
          <Modal.Body style={{ maxHeight: "70vh", overflowY: "auto" }}>
            <p>
              <span>
                You have indicated that Co-Applicant No. 1 is an existing
                member.
              </span>
            </p>
            <p>
              <span>
                If the person is not listed below, try broadening your search
                using the criteria fields provided.
              </span>
            </p>
            {this.renderPersonalMembers()}
            <div className="[ mb-3 ]">
              <div className="[ row ]">
                <div className="[ col-lg-6 ] [ offset-lg-3 ]">
                  <button
                    type="button"
                    className="[ btn  submit-btn ] [ w-100 ]"
                    disabled={!applicantId}
                    onClick={() => handleContinueInBranchJoint(applicantId)}
                    style={{
                      backgroundColor: choice === "" ? "#ccc" : "#5ba7f7",
                      color: "white",
                      border: "none",
                      borderRadius: "8px",
                      padding: "12px 24px",
                      fontSize: "16px",
                      fontWeight: "600",
                      textTransform: "uppercase",
                      cursor: choice === "" ? "not-allowed" : "pointer",
                      transition: "all 0.3s ease",
                    }}
                  >
                    {STRINGS.COMMON.CONTINUEBTN}
                  </button>
                </div>
              </div>
            </div>
          </Modal.Body>
        </Modal>
      </>
    );
  }
}

ExistingMember.propTypes = {
  handleContinue: PropTypes.func,
  onMemberSelected: PropTypes.func,
  doAccountSearch: PropTypes.func.isRequired,
};

ExistingMember.defaultProps = {
  handleContinue: () => {},
  onMemberSelected: null,
};

const mapDispatchToProps = {
  doAccountSearch,
};

export default connect(null, mapDispatchToProps)(ExistingMember);
